const numProjects = 6

export default {
  data: function () {
    return {
      recoProjects: [],
      projectIDs: [],
      show: false
    }
  },
  mounted: function () {
    if (this.project.categories) {
      // If the current project has categories get what's trending in each category
      this.getTrendingByCategory()
    } else {
      // Otherwise recommend popular projects
      this.getPopularProjects()
    }
  },
  computed: {
    getProjects () {
      return this.recoProjects.slice(0, numProjects)
    }
  },
  methods: {
    getTrendingByCategory: function () {
      const params = { limit: 6, offset: 0, sort: 'newest', includeCategories: this.project.categories.map((category) => category.id) }
      this.$store.dispatch('getPopularProjectsByCategory', params).then((response) => {
        const projects = response.projects
        projects.forEach((project) => {
          if (this.isProjectPushable(project)) {
            this.recoProjects.push(project)
          }
        })

        if (!this.recoProjects.length || this.recoProjects.length < numProjects) {
          this.getPopularProjects()
        }
      }, () => {
        this.getPopularProjects()
      })
    },
    getPopularProjects: function () {
      const excludeIDS = this.recoProjects.map((project) => project.id)
      const params = { limit: (numProjects - this.recoProjects.length), offset: 0, query: 'month', filter: '', sort: 'newest', exclude: excludeIDS }
      this.$store.dispatch('getPopularProjects', params).then((response) => {
        const projects = response.projects
        if (!projects || !projects.length) {
          return
        }
        projects.forEach((project) => {
          if (this.isProjectPushable(project)) {
            this.recoProjects.push(project)
          }
        })
        if (!this.recoProjects.length || this.recoProjects.length < numProjects) {
          this.getFeaturedProjects()
        }
      })
    },
    getFeaturedProjects: function () {
      const excludeIDS = this.recoProjects.map((project) => project.id)
      const params = { limit: (numProjects - this.recoProjects.length), offset: 0, filter: '', sort: 'newest', exclude: excludeIDS }
      this.$store.dispatch('getFeaturedProjects', params).then((response) => {
        const projects = response.projects
        projects.forEach((project) => {
          if (this.isProjectPushable(project)) {
            this.recoProjects.push(project)
          }
        })
      })
    },
    isProjectPushable: function (project) {
      if (this.projectIDs.indexOf(project.id) === -1 && this.project.id !== project.id) {
        this.projectIDs.push(project.id)
        return true
      }
      return false
    }
  }
}
